export default __webpack_public_path__ + "static/media/homepage_slider3.f8857196.webp";